import {
  GET_COUPONS_SUCCESS,
  GET_COUPONS_FAIL,
  GET_COUPON_SUCCESS,
  GET_COUPON_FAIL,
  CREATE_COUPON_SUCCESS,
  CREATE_COUPON_FAIL,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_FAIL,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAIL,
  CLEAR_COUPON_ERROR,
  CLEAR_SELECTED_COUPON,
} from "./actionTypes"

const INIT_STATE = {
  coupons: [],
  selectedCoupon: null,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
}

const CouponsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get all coupons
    case "GET_COUPONS":
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.payload.items || [],
        pagination: {
          pageIndex: action.payload.pageIndex,
          pageSize: action.payload.pageSize,
          totalCount: action.payload.totalCount,
          totalPages: action.payload.totalPages,
          hasPreviousPage: action.payload.hasPreviousPage,
          hasNextPage: action.payload.hasNextPage,
        },
        error: null,
      }

    case GET_COUPONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get single coupon
    case "GET_COUPON":
      return {
        ...state,
        loading: true,
        selectedCoupon: null,
        error: null,
      }

    case GET_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCoupon: action.payload,
        error: null,
      }

    case GET_COUPON_FAIL:
      return {
        ...state,
        loading: false,
        selectedCoupon: null,
        error: action.payload,
      }

    // Create coupon
    case "CREATE_COUPON":
      return {
        ...state,
        loading: true,
        createSuccess: false,
        error: null,
      }

    case CREATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: true,
        error: null,
      }

    case CREATE_COUPON_FAIL:
      return {
        ...state,
        loading: false,
        createSuccess: false,
        error: action.payload,
      }

    // Update coupon
    case "UPDATE_COUPON":
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        error: null,
      }

    case UPDATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        error: null,
      }

    case UPDATE_COUPON_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        error: action.payload,
      }

    // Delete coupon
    case "DELETE_COUPON":
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
        error: null,
      }

    case DELETE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        error: null,
      }

    case DELETE_COUPON_FAIL:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
        error: action.payload,
      }

    // Clear errors and state
    case CLEAR_COUPON_ERROR:
      return {
        ...state,
        error: null,
      }

    case CLEAR_SELECTED_COUPON:
      return {
        ...state,
        selectedCoupon: null,
      }

    default:
      return state
  }
}

export default CouponsReducer
